import { FC } from "react";
import { IconPropsType } from ".";

export const Guest: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.75 8.2V6.8C10.75 6.0268 10.1904 5.4 9.5 5.4C8.80964 5.4 8.25 6.0268 8.25 6.8V8.2C8.25 8.9732 8.80964 9.6 9.5 9.6C10.1904 9.6 10.75 8.9732 10.75 8.2ZM9.5 4C8.11929 4 7 5.2536 7 6.8V8.2C7 9.7464 8.11929 11 9.5 11C10.8807 11 12 9.7464 12 8.2V6.8C12 5.2536 10.8807 4 9.5 4Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.75 5.2V3.8C16.75 3.0268 16.1904 2.4 15.5 2.4C14.8096 2.4 14.25 3.0268 14.25 3.8V5.2C14.25 5.9732 14.8096 6.6 15.5 6.6C16.1904 6.6 16.75 5.9732 16.75 5.2ZM15.5 1C14.1193 1 13 2.2536 13 3.8V5.2C13 6.7464 14.1193 8 15.5 8C16.8807 8 18 6.7464 18 5.2V3.8C18 2.2536 16.8807 1 15.5 1Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.625 20V17.7143C13.625 15.3474 11.7782 13.4286 9.5 13.4286C7.22183 13.4286 5.375 15.3474 5.375 17.7143V20C5.375 20.3156 5.62124 20.5714 5.925 20.5714H13.075C13.3788 20.5714 13.625 20.3156 13.625 20ZM9.5 12C6.46243 12 4 14.5584 4 17.7143V20C4 21.1046 4.86185 22 5.925 22H13.075C14.1381 22 15 21.1046 15 20V17.7143C15 14.5584 12.5376 12 9.5 12Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1763 10.75C14.5071 10.75 13.9155 11.1849 13.7159 11.8237L12.2842 11.3763C12.6795 10.1113 13.851 9.25 15.1763 9.25H15.7223C18.499 9.25 20.75 11.501 20.75 14.2778V16C20.75 17.5188 19.5188 18.75 18 18.75H16.5V17.25H18C18.6904 17.25 19.25 16.6904 19.25 16V14.2778C19.25 12.3294 17.6706 10.75 15.7223 10.75H15.1763Z"
        fill={props.color}
      />
    </svg>
  );
};
